import { render, staticRenderFns } from "./zhanzhu.vue?vue&type=template&id=14032411&scoped=true"
import script from "./zhanzhu.vue?vue&type=script&lang=js"
export * from "./zhanzhu.vue?vue&type=script&lang=js"
import style0 from "./zhanzhu.vue?vue&type=style&index=0&id=14032411&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14032411",
  null
  
)

export default component.exports